import { LitEntity, html } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import './work-order-reschedule-modal';

class WorkOrderRescheduleButton extends LitEntity {
  static get properties() {
    return {
      showModal: { type: Boolean },
    };
  }

  static get styles() {
    return sharedStyles;
  }

  render() {
    if (!this.entity || !this.entity.hasAction('update-scheduled-for')) {
      return html``;
    }
    return html`
      <button class="button button--contained" @click="${this._onClick}">Reschedule</button>
      <work-order-reschedule-modal
        .href="${this.href}"
        ?hide="${!this.showModal}"
        @close="${() => this.showModal = false}"
        @response="${({ detail }) => this.dispatchEvent(new CustomEvent('response', { detail, bubbles: true, composed: true }))}"
      ></work-order-reschedule-modal>
    `;
  }

  _onClick(e) {
    e.stopPropagation();
    this.showModal = true;
  }
}

window.customElements.define('work-order-reschedule-button', WorkOrderRescheduleButton);
